var map = {
	"./figma-home/banner-big-paris.png": "./src/assets/figma-home/banner-big-paris.png",
	"./figma-home/banner-bonjur-france.png": "./src/assets/figma-home/banner-bonjur-france.png",
	"./figma-home/banner-ciao-italia.png": "./src/assets/figma-home/banner-ciao-italia.png",
	"./figma-home/banner-une-udhetim.png": "./src/assets/figma-home/banner-une-udhetim.png",
	"./figma-home/hero-book-rome.png": "./src/assets/figma-home/hero-book-rome.png",
	"./figma-home/icon-arrow.svg": "./src/assets/figma-home/icon-arrow.svg?1c7e",
	"./figma-home/icon-arrow2.svg": "./src/assets/figma-home/icon-arrow2.svg?b097",
	"./figma-home/icon-cart.svg": "./src/assets/figma-home/icon-cart.svg?9519",
	"./figma-home/icon-favorites.svg": "./src/assets/figma-home/icon-favorites.svg?ab77",
	"./figma-home/icon-like.svg": "./src/assets/figma-home/icon-like.svg?1ab3",
	"./figma-home/icon-search.svg": "./src/assets/figma-home/icon-search.svg?a2c5",
	"./figma-home/icon-step-confirm.png": "./src/assets/figma-home/icon-step-confirm.png",
	"./figma-home/icon-step-design.png": "./src/assets/figma-home/icon-step-design.png",
	"./figma-home/icon-step-layout.png": "./src/assets/figma-home/icon-step-layout.png",
	"./figma-home/icon-step-order.png": "./src/assets/figma-home/icon-step-order.png",
	"./figma-home/icon-step-photos.png": "./src/assets/figma-home/icon-step-photos.png",
	"./figma-home/icon-step-upload.png": "./src/assets/figma-home/icon-step-upload.png",
	"./figma-home/icon-user.svg": "./src/assets/figma-home/icon-user.svg",
	"./images/Cifti.png": "./src/assets/images/Cifti.png",
	"./images/CoupleMain.png": "./src/assets/images/CoupleMain.png",
	"./images/MemoryBook.png": "./src/assets/images/MemoryBook.png",
	"./images/Nena.png": "./src/assets/images/Nena.png",
	"./images/baby4.png": "./src/assets/images/baby4.png",
	"./images/baby5.png": "./src/assets/images/baby5.png",
	"./images/img1.png": "./src/assets/images/img1.png",
	"./images/img2.png": "./src/assets/images/img2.png",
	"./images/img3.png": "./src/assets/images/img3.png",
	"./images/img4.png": "./src/assets/images/img4.png",
	"./images/wall01.jpg": "./src/assets/images/wall01.jpg",
	"./images/wall02.jpg": "./src/assets/images/wall02.jpg",
	"./images/wall03.jpg": "./src/assets/images/wall03.jpg",
	"./images/wall1.png": "./src/assets/images/wall1.png",
	"./images/wall2.png": "./src/assets/images/wall2.png",
	"./images/wall3.png": "./src/assets/images/wall3.png",
	"./images/wallpaperBook.png": "./src/assets/images/wallpaperBook.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";